<template>
	<el-card>
		<div style="width: 50%;">
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="上传方式">
					<el-radio-group v-model="form.uploadType">
						<el-radio :label="1" border>本地服务器</el-radio>
						<el-radio :label="2" border>阿里云OSS</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="Access Key">
					<el-input v-model="form.keyId"></el-input>
				</el-form-item>
				<el-form-item label="Secret Key">
					<el-input v-model="form.keySecret"></el-input>
				</el-form-item>
				<el-form-item label="OSS地址">
					<el-input v-model="form.OssAddress"></el-input>
				</el-form-item>
				<el-form-item label="空间名称">
					<el-input v-model="form.OssName"></el-input>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="onSubmit">提交</el-button>
		</div>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					uploadType: '',
					OssAddress: '',
					OssName: '',
					keyId: '',
					keySecret: '',
				},
			}
		},
		created() {
			this.getSysInfo();
		},
		methods: {
			onSubmit() {
				this.$H.post("system/uploadType",this.form).then( res =>{
					if(res.code == 200){
						this.$message.success("保存成功");
					}
				})
			},
			getSysInfo() {
				this.$H.get("system/uploadConfig").then(res => {
					res.result.extend = JSON.parse(res.result.extend);
					let data = res.result;
					this.form = {
						uploadType: parseInt(data.value),
						OssAddress: data.extend.endpoint,
						OssName: data.extend.OssName,
						keyId: data.extend.accessKeyId,
						keySecret: data.extend.accessKeySecret
					}
				})
			}
		}
	}
</script>

<style>
</style>
